import { FC } from 'react';

import styles from './RequiredLabel.module.scss';

const RequiredLabel: FC = () => {
  return <span className={styles.required_label}>(必須)</span>;
};

export default RequiredLabel;
